export default __webpack_public_path__ + "static/media/prof.7823b463.png";